import { TransactionFeeItem } from "rujira.ui";

export { TransferTimeRow as WithdrawalTimeRow } from "rujira.ui";
export { TransactionFeeSummary as WithdrawalFeeSummary } from "rujira.ui";

type WithdrawalFeeItem = TransactionFeeItem & { valueUsd: bigint };

type WithdrawalFeeData = Pick<
  WithdrawalFeeItem,
  "symbol" | "amount" | "decimals"
>;

export interface WithdrawalFeeSummaryInput {
  networkFee?: WithdrawalFeeData;
  networkFees?: (WithdrawalFeeData & { valueUsd: bigint })[];
  networkFeeValueUsd: bigint;
  withdrawalFee?: WithdrawalFeeData;
  withdrawalFeeValueUsd: bigint;
  networkFeeLabel: string;
  withdrawalFeeLabel: string;
}

export const buildWithdrawalFeeSummary = ({
  networkFee,
  networkFees,
  networkFeeValueUsd,
  withdrawalFee,
  withdrawalFeeValueUsd,
  networkFeeLabel,
  withdrawalFeeLabel,
}: WithdrawalFeeSummaryInput) => {
  const resolvedNetworkFees =
    networkFees ||
    (networkFee ? [{ ...networkFee, valueUsd: networkFeeValueUsd }] : []);
  const fees = [
    ...resolvedNetworkFees.map((fee, index) => ({
      key: `network-${index}`,
      label: networkFeeLabel,
      ...fee,
    })),
    withdrawalFee && {
      key: "withdrawal",
      label: withdrawalFeeLabel,
      ...withdrawalFee,
      valueUsd: withdrawalFeeValueUsd,
    },
  ].filter((fee): fee is WithdrawalFeeItem => Boolean(fee));

  return {
    fees,
    totalValueUsd:
      resolvedNetworkFees.reduce((total, fee) => total + fee.valueUsd, 0n) +
      withdrawalFeeValueUsd,
  };
};
